/*
 * @Author: qiuwenjing qiuwenjing@vip56.cn
 * @Date: 2024-06-20 10:55:05
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-07-02 17:11:48
 * @FilePath: \projectManagementFrontd:\project\app\PosGarmentMerchant-Front\src\common\util\calculate.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Decimal from "decimal.js"  // 具体文件中引入
export default {
    /**加法 */
    addition(a,b,num:number=2,origin:boolean=false){
        let str = "";
        let val = new Decimal(a).add(new Decimal(b)).toNumber();
        if(origin){
            str=val.toString();
        }else{
            if(val.toString().indexOf('.')>-1){
                let pos = val.toString().indexOf('.');
                str  = val.toString().slice(0,pos+num+1);
            }else{
                str =val+'.0'
            }
        }
        return Number(str);
    },
    /**减法 */
    subtraction(a,b,num:number=2,origin:boolean=false){
        let str = "";
        let val = new Decimal(a).sub(new Decimal(b)).toNumber();
        if(origin){
            str=val.toString();
        }else{
            if(val.toString().indexOf('.')>-1){
                let pos = val.toString().indexOf('.');
                str  = val.toString().slice(0,pos+num+1);
            }else{
                str =val+'.0'
            }
        }
        return Number(str);
    },
    /**乘法 */
    multiplication(a,b,num:number=2,origin:boolean=false){
        let str = "";
        let val = new Decimal(a).mul(new Decimal(b)).toNumber();
        if(origin){
            str=val.toString();
        }else{
            if(val.toString().indexOf('.')>-1){
                let pos = val.toString().indexOf('.');
                str  = val.toString().slice(0,pos+num+1);
            }else{
                str =val+'.0'
            }
        }
        return Number(str);
    },
    /**除法 */
    division(a,b,num:number=2,origin:boolean=false){
        let str = "";
        let val = new Decimal(a).div(new Decimal(b)).toNumber();
        if(origin){
            str=val.toString();
        }else{
            if(val.toString().indexOf('.')>-1){
                let pos = val.toString().indexOf('.');
                str  = val.toString().slice(0,pos+num+1);
            }else{
                str =val+'.0'
            }
        }
        return Number(str);
    },
}


// WEBPACK FOOTER //
// ./src/common/util/calculate.ts